import DataProvider, { Store } from "./DataProvider";
import React from "react";

export const PageDataProvider = ({ value, children }: { value: Store; children: any }) => {
    return <DataProvider value={value}>{children}</DataProvider>;
};
